import { cardsData } from '@/mocks/chiguaHomeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门吃瓜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            编辑精选的51国产吃瓜在线今日吃瓜热点内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article key={card.id} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-background-50 text-[11px] font-medium rounded-md whitespace-nowrap">
                  {card.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views} 阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}